<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

<p-heading tag="h1" class="text-balance mt-fluid-lg">
  {{ 'signup.activateAccount.confirmIdentity.headline' | translate }}
</p-heading>
<div class="w-full">
  @if (isSecondFactorDob) {
    <div>
      <myprofile-signup-ui-dob-confirm-identity
        [currentPageName]="currentPageName"
        [errorMessages]="messages"
      ></myprofile-signup-ui-dob-confirm-identity>
    </div>
  }
  @if (!isSecondFactorDob) {
    <div>
      <myprofile-signup-ui-sms-confirm-identity
        [mobile]="mobile"
        [currentPageName]="currentPageName"
        [messages]="messages"
        [messageState]="messageState"
      ></myprofile-signup-ui-sms-confirm-identity>
    </div>
  }

  <myprofile-signup-ui-cancel-activation></myprofile-signup-ui-cancel-activation>

  @if (isAddVehicleLeanActivation) {
    <p-text class="mt-fluid-md">
      <span [innerHTML]="leanActivationText"></span>
    </p-text>
  }
</div>
